// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"sL-z","loadingMedia":"tL-z","reviewsImagesAndVideos":"uL-z","limitHeight":"vL-z"};